// extracted by mini-css-extract-plugin
module.exports = {"main":"cookies-module--main--2ojG_","nolist":"cookies-module--nolist--36weg"};